require('./src/style.less')

console.log("Summer heat loaded.")



// WEBPACK FOOTER //
// ./theme/micro-summerheat/index.js